import numeral from 'numeral';
import moment from "moment-timezone";
"numeral/locales/es";

export const toMoneyFormat = (number) => {
    return numeral(parseInt(number)).format('$0,0');
}

export const firstChartUpperString = (string) => {

    return string.split(" ").map((tempString) => {
        return tempString.charAt(0).toUpperCase() + tempString.slice(1);
    }).join(" ")
}

export const onlyNumbers = (value) => {
    let newValue = value.replace(/[^0-9]/g, '');
    if (newValue.length > 1 && newValue.charAt(0) === '0') {
        newValue = newValue.slice(1);
    }
    return  newValue
};

export const normalizeText = (text) => (text || "")
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

// Busca en una lista de {value, label} la opcion cuyo value coincide con el texto
// ignorando mayusculas, tildes y espacios sobrantes (ej. "CHILENA" -> "Chilena").
export const findOptionByText = (options, text) => {
    const target = normalizeText(text);
    if (!target) return undefined;
    return (options || []).find((row) => normalizeText(row.value) === target);
};

export const eventColors = (event) => {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
};

export const getUrl = (config) => {
    const url = config?.url
    const method =  config?.method
    return `${method}.${url}`
}

export const getWorkerScheduleConflicts = (dictReservation, workerId, dateEvent, startDate, endDate, excludeReservationId = null) => {
    const conflicts = [];
    Object.keys(dictReservation).forEach((key) => {
        if (moment(key).format("YYYY-MM-DD") !== dateEvent) {
            return;
        }
        const reservation = dictReservation[key][workerId];
        if (!reservation) {
            return;
        }
        if (excludeReservationId !== null && reservation.id === excludeReservationId) {
            return;
        }
        const overlaps = moment(reservation.fecha_hora).isBefore(endDate) && moment(reservation.fecha_final).isAfter(startDate);
        if (overlaps) {
            conflicts.push(reservation);
        }
    });
    return conflicts;
}
